import { render, staticRenderFns } from "./QuillContentViewer.vue?vue&type=template&id=172f2dad&"
import script from "./QuillContentViewer.vue?vue&type=script&lang=js&"
export * from "./QuillContentViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports